import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
// import axios from 'axios'
// import VueAxios from "vue-axios";
import 'lib-flexible/flexible' //转使用rem
import {DatePicker,Input,Loading,Rate,Message,MessageBox,Upload,Dropdown,DropdownMenu,DropdownItem,Select,Option} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false  
// Vue.use(VueAxios, axios)
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Rate)
Vue.use(Upload)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Select)
Vue.use(Option)
// Vue.use(Message)
// Vue.prototype.$loading = Loading;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

//router拦截
// router.beforeEach((to,from,next) => {
//   if (to.meta.login_request) {
      
//   }else {
//     next()
//   }
// })


// WEBPACK FOOTER //
// ./src/main.js